import * as React from 'react'

import { Box, Divider, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

const BreakSourceTooltip = () => {
  const [openInfo, toggleOpenInfo] = useToggle()

  return (
    <Tooltip.ItemList attachment="bottom center" open={openInfo} toggle={toggleOpenInfo}>
      <Icon.Medium icon="info-circle" color="grey800" />
      <Box textAlign="left" gap="s12">
        <Text weight="semibold" size="300" color="grey000White">
          {i18n.t(
            'time_tracking.settings.breaks.instance.break_source.tooltip.after_amount_of_hours.title'
          )}
        </Text>
        <Text.Normal>
          {i18n.t(
            'time_tracking.settings.breaks.instance.break_source.tooltip.after_amount_of_hours.description'
          )}
        </Text.Normal>

        <Divider backgroundColor="FFFFFF" />

        <Text weight="semibold" size="300" color="grey000White">
          {i18n.t(
            'time_tracking.settings.breaks.instance.break_source.tooltip.at_planned_time.title'
          )}
        </Text>

        <Text.Normal>
          {i18n.t(
            'time_tracking.settings.breaks.instance.break_source.tooltip.at_planned_time.description'
          )}
        </Text.Normal>
      </Box>
    </Tooltip.ItemList>
  )
}

export default observer(BreakSourceTooltip)
